export default "/images/14333ed20492860983b9ab7edafe8c0d.avif";